(function () {
  "use strict";

  class ConvxBlogDropdown extends HTMLElement {
    connectedCallback() {
      const titleText = this.getAttribute("title") || "Toggle";

      // Only insert header if not already present
      if (!this.querySelector(".convx__blog-dropdown")) {
        const titleEl = document.createElement("div");
        titleEl.className = "convx__blog-dropdown";
        titleEl.innerHTML = `
                            <span class="convx__blog-label">${titleText}</span>
                            <span class="convx__blog-chevron"><svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M948.560332 281.179984c-13.765515-13.833053-36.127825-13.833053-49.89334 0L511.991302 668.591431 125.313565 281.179984c-13.763468-13.798261-36.093033-13.798261-49.856501 0-13.799284 13.798261-13.799284 36.161594 0 49.993624l410.857439 411.674037c7.067976 7.085372 16.402575 10.521634 25.675776 10.331299 9.274224 0.191358 18.608823-3.245927 25.677822-10.331299l410.891208-411.708829c6.863315-6.89913 10.331299-15.940041 10.331299-24.979928S955.423647 288.078091 948.560332 281.179984z"/></svg></span>
                        `;
        this.insertBefore(titleEl, this.firstChild);
      }

      const toggleBtn = this.querySelector(".convx__blog-dropdown");
      const content = this.querySelector(".convx__blog-content");
      const chevron = this.querySelector(".convx__blog-chevron");

      if (!toggleBtn || !content || !chevron) return;

      toggleBtn.addEventListener("click", () => {
        const isOpen = content.classList.toggle("open");
        chevron.classList.toggle("open", isOpen);
        toggleBtn.classList.toggle("open", isOpen);
      });
    }
  }

  function blog_dropdown() {
    document.querySelectorAll("[convx-blog-dropdown]").forEach((dropdown) => {
      const titleText = dropdown.getAttribute("title") || "Toggle";

      if (!dropdown.querySelector(".convx__blog-dropdown")) {
        const titleEl = document.createElement("div");
        titleEl.className = "convx__blog-dropdown";
        titleEl.innerHTML = `
            <span class="convx__blog-label">${titleText}</span>
            <span class="convx__blog-chevron">
                <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024">
                    <path d="M948.560332 281.179984c-13.765515-13.833053-36.127825-13.833053-49.89334 0L511.991302 668.591431 125.313565 281.179984c-13.763468-13.798261-36.093033-13.798261-49.856501 0-13.799284 13.798261-13.799284 36.161594 0 49.993624l410.857439 411.674037c7.067976 7.085372 16.402575 10.521634 25.675776 10.331299 9.274224 0.191358 18.608823-3.245927 25.677822-10.331299l410.891208-411.708829c6.863315-6.89913 10.331299-15.940041 10.331299-24.979928S955.423647 288.078091 948.560332 281.179984z"/>
                </svg>
            </span>
        `;
        dropdown.insertBefore(titleEl, dropdown.firstChild);
      }

      const toggleBtn = dropdown.querySelector(".convx__blog-dropdown");
      const content = dropdown.querySelector(".convx__blog-content");
      const chevron = dropdown.querySelector(".convx__blog-chevron");

      if (!toggleBtn || !content || !chevron) return;

      toggleBtn.addEventListener("click", () => {
        const isOpen = content.classList.toggle("open");
        chevron.classList.toggle("open", isOpen);
        toggleBtn.classList.toggle("open", isOpen);
      });
    });
  }

  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";

    customElements.define("convx-blog-dropdown", ConvxBlogDropdown);
    blog_dropdown();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
